import React from 'react';
import { Title } from '../../components/components'
import { useTranslation } from 'react-i18next';

function Api(props) {
	const { t, i18n } = useTranslation();
	return (
		<Title main={t("menu.api")} />
	)
}

 export default Api
